module.exports = __webpack_public_path__ + "static/media/pep.3793e5c6.png";